import type { LogoVsLogoLeague } from '../types';
import { premierLeague } from './premier-league';
import { urbaTop14 } from './urba-top14';
import { brasileiraoSerieA } from './brasileirao-serie-a';
import { brasileiraoSerieB } from './brasileirao-serie-b';
import { brasileiraoSerieC } from './brasileirao-serie-c';
import { copinha } from './copinha';
import { eredivisie } from './eredivisie';
import { bundesliga } from './bundesliga';
import { ligue1 } from './ligue1';
import { serieA } from './serie-a';
import { laliga } from './laliga';

// To add a league: drop a new file in this folder exporting a LogoVsLogoLeague,
// then append it here.
export const LOGO_VS_LOGO_LEAGUES: LogoVsLogoLeague[] = [
  premierLeague,
  urbaTop14,
  brasileiraoSerieA,
  brasileiraoSerieB,
  brasileiraoSerieC,
  copinha,
  eredivisie,
  bundesliga,
  ligue1,
  serieA,
  laliga
];
